import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import pick from 'lodash.pick';
import { getAction, httpAction } from '@api/manage';
import SelectProductModal from '@views/assets/SelectProductModal';
import SelectSiteListModal from '@views/assets/SelectSiteListModal';
import { queryUserTreeList } from '@api/api';
import { accMul } from '@/utils/util';
import moment from 'moment';
import IwsUpload from '@comp/upload/IwsUpload';
var configColumns = [{
  title: '排序',
  dataIndex: '',
  key: 'rowIndex',
  width: '5%',
  align: 'center',
  customRender: function customRender(t, r, index) {
    return parseInt(index) + 1;
  }
}, {
  title: '原料名称',
  dataIndex: 'productName',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'productId'
  }
}, {
  title: '单位含量',
  dataIndex: 'productNum',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'productNum'
  }
}, {
  title: '单位',
  dataIndex: 'productUnit_dictText',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'productUnit'
  }
}, {
  title: '原料编号',
  dataIndex: 'assetCode',
  align: 'center',
  width: '15%',
  scopedSlots: {
    customRender: 'assetId'
  }
}, {
  title: '原料存量',
  dataIndex: 'assetNum',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'assetNum'
  }
}, {
  title: '使用量',
  dataIndex: 'quantity',
  align: 'center',
  width: '10%',
  scopedSlots: {
    customRender: 'quantity'
  }
}, {
  title: '备注',
  dataIndex: 'remark',
  align: 'center',
  width: '20%',
  scopedSlots: {
    customRender: 'remark'
  }
}];
/*DataSource 定义数据源数组*/

var configData = []; // PS相关的KEY不能为title关键字

var addConfigDataIndex = 0;
export default {
  name: 'ReagentMixModal',
  components: {
    SelectProductModal: SelectProductModal,
    SelectSiteListModal: SelectSiteListModal,
    IwsUpload: IwsUpload
  },
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      title: '试剂配制表单',
      tableName: 'om_reagent_mix',
      form_fields: ['productId', 'userId', 'mixNum', 'remark', 'status', 'volume', 'supplierId', 'density', 'mixReason', 'siteId'],
      form_fields_time: ['mixTime', 'expiryDate'],
      validatorRules: {
        productId: {
          rules: [{
            required: true,
            message: '请选择产品!'
          }]
        },
        userId: {
          rules: [{
            required: true,
            message: '请输入配制人员!'
          }]
        },
        mixTime: {
          rules: [{
            required: true,
            message: '请输入配制时间!'
          }]
        },
        expiryDate: {
          rules: [{
            required: true,
            message: '请输入有效期至!'
          }]
        },
        mixNum: {
          rules: [{
            required: true,
            message: '请输入配制数量!'
          }]
        },
        volume: {
          rules: [{
            required: true,
            message: '请输入单位体积!'
          }]
        },
        density: {
          rules: [{
            required: true,
            message: '请输入浓度!'
          }]
        },
        supplierId: {
          rules: [{
            required: true,
            message: '请选择供应商!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请输入状态!'
          }]
        },
        mixReason: {
          rules: [{
            required: true,
            message: '请选择配置原因!'
          }]
        }
      },
      validity: 0,
      companyList: [],
      selectedProduct: [],
      productIds: [],
      userTree: [],
      //人员信息,
      loginUser: '',
      limitSelectDate: {},
      disableSubmitProduct: false,
      configData: configData,
      addConfigDataIndex: addConfigDataIndex,
      configColumns: configColumns,
      ModalText: '原料更换新增后，不可编辑删除，请确认数据录入是否正确',
      visible1: false,
      selectedSite: [],
      siteIds: '',
      // siteAssetList: [],
      url: {
        chemicalInfo: '/om/reagent/mix/queryChemical/',
        chemicalSum: '/ea/asset/chemical/',
        queryReagentMixPart: '/om/reagent/mix/',
        queryCompany: '/ea/company/info/queryCompanyName',
        querySiteAsset: '/ea/asset/info/queryBySiteId/'
      }
    };
  },
  props: ['pagePath'],
  created: function created() {
    this.loginUser = this.$store.getters.userInfo.id;
  },
  methods: {
    moment: moment,
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      console.log(this.model);
      this.visible = true;
      this.visible1 = false;
      this.selectedProduct = [];
      this.selectedSite = [];
      this.productIds = [];
      this.loadTreeList(); // this.loadCompany() //厂商

      this.configData = [];

      if (this.model.id != null) {
        this.productIds = this.model.productId;
        this.selectedSite = this.model.siteName;
        this.selectedProduct = this.model.productName;
        this.loadReagentMixPart(this.model.id, this.model.productId);
      } else {
        this.model.userId = this.loginUser;
      }

      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    selectSite: function selectSite() {
      this.$refs.SiteListModal.add(this.selectedSite, this.siteIds);
    },
    // //获取站点仪器设备
    // loadSiteAsset() {
    //   var that = this
    //   debugger
    //   that.siteAssetList = []
    //   getAction(that.url.querySiteAsset + that.siteIds).then(res => {
    //     if (res.success) {
    //       that.siteAssetList = res.result
    //     }
    //   })
    // },
    close: function close() {
      this.$emit('close');
      this.visible = false;
      this.visible1 = false;
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this;

      if (that.configData.length != 0) {
        this.visible1 = false; // 触发表单验证

        this.form.validateFields(function (err, values) {
          if (!err) {
            that.confirmLoading = true;
            var formData = Object.assign(that.model, values);
            formData.mixTime = formData.mixTime ? formData.mixTime.format('YYYY-MM-DD HH:mm:ss') : null;
            formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
            formData.productId = that.productIds == [] || that.productIds.length == 0 ? null : that.productIds;
            formData.siteId = that.siteIds == [] || that.siteIds.length == 0 ? null : that.siteIds;
            var mixPartParams = [];
            var chemicalParams = [];
            console.log('that.configData', that.configData);
            var state = false;
            var stateIndex = 0;

            for (var i = 0; i < that.configData.length; i++) {
              var e = that.configData[i];

              if (!e.assetId || !e.quantity && e.quantity !== 0) {
                state = true;
                stateIndex = i;
                break;
              }

              var mixPartList = {};
              var chemicalList = {};
              chemicalList.id = mixPartList.assetId = e.assetId;
              chemicalList.surplus = mixPartList.quantity = e.quantity;
              mixPartList.remark = e.remark;
              mixPartParams.push(mixPartList);
              chemicalParams.push(chemicalList);
            }

            if (state) {
              that.$notification.warning({
                message: "\u914D\u7F6E\u539F\u6599\u6E05\u5355\u4E2D\u7684\u7B2C".concat(stateIndex + 1, "\u9879\u6709\u672A\u586B\u5165\u7684\u539F\u6599\u7F16\u53F7\u6216\u4F7F\u7528\u91CF")
              });
              that.confirmLoading = false;
              return;
            }

            formData.reagentMixPartList = mixPartParams;
            formData.assetChemicalList = chemicalParams;
            var httpurl = '',
                method = '';

            if (!_this2.model.id) {
              httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
              method = 'post';
            } else {
              httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
              method = 'put';
            }

            httpAction(httpurl, formData, method).then(function (res) {
              if (res.success) {
                _this2.$refs.iwupload.resetUploadFiles();

                that.$notification.success({
                  message: res.message
                });
                that.$emit('ok');
                that.close();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            }).finally(function () {
              that.confirmLoading = false;
            });
          }
        });
      } else {
        this.$message_custom('配制原料清单为空,不能配置试剂', 'error');
      }
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    selectProducts: function selectProducts() {
      this.$refs.ProductListModal.category = 22;
      this.$refs.ProductListModal.disableSubmit = true;
      this.$refs.ProductListModal.add(this.selectedProduct, this.productIds);
    },
    // 子modal回调
    choseSite: function choseSite(siteList) {
      // debugger
      this.selectedSite = [];
      this.siteIds = [];
      this.instrumentId = []; // this.siteAssetList = []

      for (var i = 0; i < siteList.length; i++) {
        this.selectedSite.push(siteList[i].name);
        this.siteIds = siteList[i].id;
      } // this.loadSiteAsset()

    },
    // 子modal回调
    choseProduct: function choseProduct(productList) {
      this.selectedProduct = [];
      this.productIds = [];

      for (var i = 0; i < productList.length; i++) {
        this.selectedProduct.push(productList[i].name);
        this.productIds = productList[i].id;

        if (productList[i].validity) {
          this.validity = productList[i].validity;
        }

        console.log("product:", productList[i]);
        this.form.setFieldsValue(_defineProperty({}, 'volume', productList[i].quantity));
        this.form.setFieldsValue(_defineProperty({}, 'density', productList[i].intensity));
      }

      this.loadConfig(this.productIds == [] || this.productIds.length == 0 ? null : this.productIds);
    },
    // 删除
    delInsurance: function delInsurance(key) {
      var newData = this.configData.filter(function (item) {
        return key != item.key;
      });
      this.configData = newData;
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var _this3 = this;

      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this3.loading = false;
        }
      });
    },
    loadConfig: function loadConfig(params) {
      var that = this;
      getAction(this.url.chemicalInfo + params).then(function (res) {
        if (res.success) {
          var paramList = [];

          for (var i = 0; i < res.result.length; i++) {
            var param = res.result[i];
            param.key = param.productId;
            param.editable = false;
            paramList.push(param);
          }

          that.configData = paramList;
        }
      });
    },
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    total: function total() {
      var that = this;
      var paramList = [];
      var mixNum = this.form.getFieldValue('mixNum');

      for (var i = 0; i < that.configData.length; i++) {
        var param = that.configData[i];
        param.quantity = accMul(param.productNum, mixNum);
        this.compare(param.assetId, param.quantity, param.index);
        paramList.push(param);
      }

      that.configData = paramList;
    },
    compare: function compare(params, quantity, index) {
      var _this4 = this;

      var that = this;
      var paramList = [];
      getAction(this.url.chemicalSum + params).then(function (res) {
        if (res.success) {
          if (index != null) {
            for (var i = 0; i < that.configData.length; i++) {
              var param = that.configData[i];

              if (i == index) {
                that.configData[index].assetNum = res.result.surplus;
              }

              paramList.push(param);
            }

            that.configData = paramList;
          }

          if (res.result.surplus < quantity) {
            _this4.$message.error('原料存量不足,请更换其他原料!', 2);
          }
        }
      });
    },
    loadReagentMixPart: function loadReagentMixPart(params, pruductId) {
      var that = this;
      getAction(this.url.queryReagentMixPart + params + '/' + pruductId).then(function (res) {
        if (res.success) {
          var paramList = [];

          for (var i = 0; i < res.result.length; i++) {
            var param = res.result[i]; // param.key = params.id

            param.productUnit_dictText = param.productunit_dictText;
            param.remark = param.detailed;
            param.assetId = param.assetCode;
            paramList.push(param);
          }

          that.configData = paramList;
        }
      });
    },
    showModal: function showModal() {
      this.visible1 = true;
    },
    handleCancel2: function handleCancel2() {
      this.visible1 = false;
    },
    changeExpiryDate: function changeExpiryDate(value) {
      if (this.validity != 0) {
        var oldExpiryDate = new Date(value.year(), value.month(), value.date());
        var newExpiryDate;
        oldExpiryDate = oldExpiryDate.setMonth(oldExpiryDate.getMonth() + this.validity);
        newExpiryDate = new Date(oldExpiryDate);
        this.form.setFieldsValue({
          expiryDate: moment(newExpiryDate, 'YYYY-MM-DD')
        });
      }
    }
  }
};